import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { NavigationService } from 'src/app/services/navigation.service';
import { CrudStatusType } from 'src/app/enum/crud-status-type';
import { RoleType } from 'src/app/enum/role-type';
import { ExcelService } from 'src/app/services/excel.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import Swal from 'sweetalert2';
import { PromotionDataService } from 'src/app/services/promotion-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manage-promotion',
  templateUrl: './manage-promotion.component.html',
  styleUrls: ['./manage-promotion.component.scss']
})
export class ManagePromotionComponent implements OnInit {
  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "PromoName",
    "PromCode",
    "StartDate",
    "EndDate",
    "promovalidity",
    "promoStatus",
    "Action"

  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  dataExcel: any = [];
  excelColumns: string[];
  filterValue: string = "";
  roleTypeEnum = RoleType;
  sessionDataString: any;

  constructor(
    private navigationService: NavigationService,
    private excelService: ExcelService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private sessionService: UserSessionService,
    private promotionservice: PromotionDataService,
    private router: ActivatedRoute
  ) {
    console.log('route', this.router.url);

  }

  ngOnInit() {
    this.getTableData();
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );
  }

  getTableData() {
    this.promotionservice.getManagePromotionDetails().subscribe((result) => {
      this.data = result
      this.dataSource = new MatTableDataSource(this.data)
    })
  }
  search(data) {
    this.promotionservice.GetPromoBySearchQuery(data).subscribe((result) => {

    })

  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearFilter() {
    const inputElement = document.getElementById('filter-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.dataSource.filter = '';
    this.searchInput.nativeElement.value = "";
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.getTableData();
  }

  goToManagePromotionAdd(id, type) {
    this.navigationService.goToManagePromotionAdd(id, type);
  }

  deleteUser(user) {
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      html: `Are you sure want to delete <b style="color:black">
        "${user.promoName}"
      </b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        let val = { PromotionId: user.id }
        this.promotionservice.deletePromoAndPromoProd(val).subscribe((result: any) => {
          this.toastr.showSuccess("Deleted Successfully");
          this.getTableData();
        });
      }
    });
  }

  preventLeadingSpace(event: Event) {
    const e = event as KeyboardEvent;
    const input = e.target as HTMLInputElement;

    if (e.key === ' ' && input.selectionStart === 0) {
      e.preventDefault();
    }
  }

}

